export type StaffRole = 'super_admin' | 'admin' | 'staff';

export interface StaffUser {
  id: string;
  email: string;
  name: string;
  role: StaffRole;
  isActive: boolean;
  loginCount: number;
  firstLoginAt: any;
  lastLoginAt: any;
  createdAt: any;
  updatedAt: any;
}

export type AuditAction =
  | 'staff.login'
  | 'staff.logout'
  | 'staff.role_updated'
  | 'vendor.submitted'
  | 'vendor.updated'
  | 'vendor.approved'
  | 'vendor.rejected'
  | 'vendor.deleted'
  | 'vendor.sharepoint_sync'
  | 'document.uploaded'
  | 'document.deleted'
  | 'settings.email_updated';

export interface AuditLogEntry {
  id: string;
  action: AuditAction;
  actorEmail: string;
  actorName: string;
  targetType?: 'vendor' | 'staff' | 'settings' | 'document';
  targetId?: string;
  targetLabel?: string;
  details?: string;
  metadata?: Record<string, unknown>;
  timestamp: any;
}

export interface EmailNotificationSettings {
  notificationEmails: string[];
  notifyOnVendorSubmission: boolean;
  notifyOnVendorUpdate: boolean;
  notifyOnVendorApproval: boolean;
  updatedAt?: any;
  updatedBy?: string;
}

export const DEFAULT_SUPER_ADMIN_EMAIL = 'emmanuel.oladayo@sunbeth.net';

export const STAFF_ROLE_LABELS: Record<StaffRole, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  staff: 'Staff',
};

export function canManageUsers(role: StaffRole | null | undefined): boolean {
  return role === 'super_admin';
}

export function canManageSettings(role: StaffRole | null | undefined): boolean {
  return role === 'super_admin' || role === 'admin';
}

export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}
